//#region Bullet list

var bulletList = {
    data: {},
    ids: [],
    sendSocketUpdate(action, controlId, taskNumber) {

        if (typeof socket !== 'undefined') {
            var socketObject = new Object();
            socketObject.action = action
            socketObject.controlid = controlId
            socketObject.number = taskNumber
            socket.send(JSON.stringify(socketObject))
        }
    },
    initializeTooltips($container) {
        tooltipHelper.init($container)
    },
    loadDescription($item, $desc) {
            $.ajax({
                url: window.location.origin + __root + "BulletList/LoadDescription",
                type: "POST",
                data: { p: $item.attr('data-p') },

                success: function (response) {
                    if (response.message === "success") {
                        $desc.html(response.info)   // wstawiamy HTML opisu
                        $desc.attr('data-loaded', '1')
                    } else {
                        console.error("LoadDescription error")
                    }
                },
                error: function () {
                    console.error("LoadDescription AJAX error")
                }
            })
        }
};

$(document).on("click", ".kdr-bullet-list-page", function () {
    let that = $(this)
    let $bulletList = that.closest(".kdr-bullet-list")
    let page = that.attr("data-page")
    let bulletListId = "#" + $bulletList.attr("id")

    let func = function () {
        $bulletList = $(bulletListId)
        $.ajax({
            type: "POST",
            url: __root + "BulletList/Page",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($bulletList),
                "page": page
            },
            success: function (response) {
                $bulletList = $(bulletListId)
                controls.magic("BulletList/Render", $bulletList, response, $bulletList)
            }
        })
    }

    let func2 = function (callback) {
        if ($bulletList.hasClass('kdr-bullet-list-lock-checkboxes')) {
            controls.lockCheckboxes($bulletList, callback)
        }
        else {
            callback && callback()
        }
    }

    if ($bulletList.hasClass('kdr-bullet-list-save-all-on-page-change')) {
        func2(function () {
            $(document).one(gridEvents.BEFORE_RENDER, bulletListId, function (event) {
                if (event.code == gridResponseCodes.SUCCESS) {
                    $(document).one(gridEvents.AFTER_RENDER, bulletListId, func)
                }
            })

            $bulletList.find('.kdr-bullet-list-save-all').click()
        })
    } else {
        func2(func)
    }
})

$(document).on(gridEvents.AFTER_RENDER, '#task-subtasks-bullet-list', function () {
    let $container = $(this)
    bulletList.initializeTooltips($container)
})

$(document).on('click', '.kdr-bullet-list-item-delete', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $container = $(this).closest('.kdr-bullet-list')
    let $item = $(this).closest('.kdr-bullet-list-item-container')
    let info = controls.getInfo($container)

    let $modal = $container.find(".kdr-bullet-list-delete-modal").clone().detach()
    let mId = $modal.prop('id') + 'clonedDetached'
    $modal.prop('id', mId)
    $('body').append($modal)

    modal.prepareModal(mId);

    $modal.on('hidden.bs.modal', function () {
        $modal.remove()
    })

    let taskNumber = $(this).closest('#kanbanDetails').find('.kanban-details-span-header').text()

    let args = {
        value: $item.attr('data-p')
    }

    $modal.find(".kdr-grid-remove-confirm").click(function () {
        $modal.modal("hide")
        $.ajax({
            type: "POST",
            url: __root + "BulletList/Act",
            datatype: "json",
            traditional: true,
            data: {
                info: info,
                magic: $container.attr("data-action"),
                args: JSON.stringify(args)
            },
            success: function (response) {
                loading.callback && loading.callback(response)
                toastr.success(__l.SuccessfullyDeleted)

                controls.refresh($container)
            }
        })
    })
    $modal.modal("show")
});

$(document).on('click', '.kdr-bullet-list-item-edit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $this = $(this)
    let taskId = $this.closest('.kdr-bullet-list').attr("data-reference")
    let itemId = $this.closest('.kdr-bullet-list-item-container').attr('data-p')

    modalHelper.getModal('BulletList/SubtaskEditModal', { p1: taskId, p2: itemId })
});

$(document).on('click', '.kdr-bullet-list-transform-to-task', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $this = $(this)
    let taskId = $this.closest('.kdr-bullet-list').attr("data-reference")
    let itemId = $this.closest('.kdr-bullet-list-item-container').attr('data-p')

    modalHelper.getModal('BulletList/SubtaskTransformToTaskModal', { p1: taskId, p2: itemId })
});

$(document).on('click', '.kdr-bullet-list-btn', function () {
    let $this = $(this)
    let taskId = $this.closest('.kdr-bullet-list').attr("data-reference")

    modalHelper.getModal('BulletList/SubtaskAddModal', { p1: taskId })
});

$(document).on('click', '.bullet-list-add-comment-modal', function (e) {
    e.preventDefault()
    e.stopPropagation()

    subtaskId = $(this).closest('.kdr-bullet-list-item-container').attr('data-subtask-p')
    $info = controls.getInfo($('.kdr-bullet-list'))
    controlId = $(this).closest('.bullet-list-comment-section').find('.kdr-grid-modal').attr('Id')

    modalHelper.getModal('BulletList/AddSubtaskCommentModal', {
        p: subtaskId
        , info: $info
        , controlId: controlId
    })
});

$(document).on('click', ".subtask-icon-btn", function (e) {
    const states = ["NEEDFIX", "FORTESTING", "DONE", "NEXTSPRINT"];

    e.preventDefault()
    e.stopPropagation()

    let currentIcon = $(this);
    let currentIndex = parseInt(currentIcon.attr("icon-index"));
    let nextIndex = (currentIndex + 1) % states.length;

    let nextIcon = currentIcon.closest('.subtask-icons-wrapper').find(".subtask-icon[icon-index=" + nextIndex + "]")

    currentIcon.addClass("hide");
    nextIcon.removeClass("hide");

    let taskNumber = $(this).closest('#kanbanDetails').find('.kanban-details-span-header').text()

    $.ajax({
        url: window.location.origin + __root + "BulletList/UpdateButtonState",
        type: "POST",
        data: { nextState: nextIndex, id: currentIcon.closest('.kdr-bullet-list-item-container').attr('data-p') },
        success: function (response) {
            console.log("Stan zaktualizowany: ", response);
            toastr.success(response.message, __l.StateUpdated)

            var socketObject = new Object();
            socketObject.action = 'CHANGECONTROL'
            socketObject.controlid = '#task-subtasks-bullet-list'
            socketObject.number = taskNumber;
            socket.send(JSON.stringify(socketObject))
        },
        error: function (xhr, status, error) {
            console.error("Błąd AJAX: ", error);
            toastr.warning(response.message, __l.Error)
        }
    });
});

$(document).on('click', ".subtask-icon-comment", function (e) {
    const states = ["DONE", "NEXTSPRINT", "COMMENT"];

    e.preventDefault()
    e.stopPropagation()

    let currentIcon = $(this);
    let currentIndex = parseInt(currentIcon.attr("icon-index"));
    let nextIndex = 2 + (currentIndex - 2 + 1) % 3;

    let nextIcon = currentIcon.closest('.subtask-icons-wrapper').find(".subtask-icon[icon-index=" + nextIndex + "]")

    currentIcon.addClass("hide");
    nextIcon.removeClass("hide");

    let taskNumber = $(this).closest('#kanbanDetails').find('.kanban-details-span-header').text()

    $.ajax({
        url: window.location.origin + __root + "BulletList/UpdateButtonState",
        type: "POST",
        data: { nextState: nextIndex, id: currentIcon.closest('.kdr-bullet-list-item-container').attr('data-p') },
        success: function (response) {
            console.log("Stan zaktualizowany: ", response);
            toastr.success(response.message, __l.StateUpdated)

            var socketObject = new Object();
            socketObject.action = 'CHANGECONTROL'
            socketObject.controlid = '#task-subtasks-bullet-list'
            socketObject.number = taskNumber;
            socket.send(JSON.stringify(socketObject))
        },
        error: function (xhr, status, error) {
            console.error("Błąd AJAX: ", error);
            toastr.warning(response.message, __l.Error)
        }
    });
});


$(document).on('click', '.kdr-bullet-list-item-container-wrapper', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $item = $(this).closest('.kdr-bullet-list-item-container')
    let $container = $(this).closest('.kdr-bullet-list')

    // przełącz rozwinięcie
    $item.toggleClass('inactive')

    // *** LAZY LOAD DESCRIPTION ***
    let $desc = $item.find('.kdr-bullet-list-description')
    if ($desc.attr('data-loaded') === "0") {
        bulletList.loadDescription($item, $desc)
    }

    $.ajax({
        url: window.location.origin + __root + "BulletList/UpdateExpandedP",
        type: "POST",
        data: {
            p: $item.attr('data-subtask-p'),
            info: controls.getInfo($container)
        },
        success: function (response) {
            controls.setInfo($container, response.info)
        },
        error: function (xhr, status, error) {
            console.error("Błąd AJAX: ", error);
            toastr.warning(response.message, __l.Error)
        }
    })
})

$(document).on('click', '.kdr-bullet-list-item-container-sort-value', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let $this = $(this)
    let $parent = $this.closest('.kdr-bullet-list')
    let p = $this.data('p')

    $.ajax({
        type: "POST",
        url: __root + "BulletList/BulletListSort",
        datatype: "json",
        traditional: true,
        data: {
            infoo: controls.getInfo($parent),
            p: p
        },
        success: function (response) {
            controls.setInfo($parent, response.info)
            controls.refresh($parent)
        },

        beforeSend: function () { $parent && loading.show($parent) },
        complete: function () { $parent && loading.hide($parent) }
    })
})

$(document).on('click', '.kdr-bullet-list-import-btn', function () {
    let $this = $(this)
    let taskId = $this.closest('.kdr-bullet-list').attr("data-reference")

    modalHelper.getModal('BulletList/SubtaskImportModal', { p1: taskId })
});

$(document).on("click", ".kdr-bullet-list-items", function () {
    let that = $(this)
    let $bulletList = that.closest(".kdr-bullet-list")
    let $loadingIndicator = $bulletList
    //$loadingIndicator.push(that.closest('.pagination-dropdown'))

    function func() {
        $.ajax({
            type: "POST",
            url: __root + "BulletList/Items",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($bulletList),
                "items": that.data("items")
            },
            success: function (response) {
                controls.magic("BulletList/Render", $bulletList, response, $loadingIndicator)
            }
        })
    }

    func()
})

//#endregion Bullet list